export const $filterFactory = (i: any) => i.get('$filter');
export const $translateFactory = (i: any) => i.get('$translate');
export const $stateParamsFactory = (i: any) => i.get('$stateParams');
export const $stateFactory = (i: any) => i.get('$state');
export const $compileFactory = (i: any) => i.get('$compile');
export const $elementFactory = (i: any) => i.get('$element');
export const $qFactory = (i: any) => i.get('$q');
export const $documentFactory = (i: any) => i.get('$document');
export const $rootScopeFactory = (i: any) => i.get('$rootScope');
export const $JobsSpeedIntervalFactory = (i: any) => i.get('JobsSpeedInterval');
export const $JobsNormalIntervalFactory = (i: any) => i.get('JobsNormalInterval');
export const $scopeFactory = (i: any) => i.get('$scope');
export const $ngReduxFactory = (i: any) => i.get('$ngRedux');
export const $UploadFactory = (i: any) => i.get('Upload');
export const widgetsHelperFactory = (i: any) => i.get('widgetsHelper');
export const $uibModalFactory = (i: any) => i.get('$uibModal');
export const $httpFactory = (i: any) => i.get('$http');
export const $statusesFactory = (i: any) => i.get('statuses');
export const LeadTimeActionsFactory = (i: any) => i.get('LeadTimeActions');
export const apiFactory = (i: any) => i.get('api');
export const JobCompletitionServiceFactory =  (i: any) => i.get('jobCompletitionService');
export const authorizationServiceFactory = (i: any) => i.get('authorizationService');
export const constsFactory = (i: any) => i.get('consts');
export const popUpModalFactory = (i: any) => i.get('popUpModal');
export const processDetailsModalServiceFactory = (i: any) => i.get('processDetailsModalService');
export const shepherdGuidenceServiceFactory = (i: any) => i.get('shepherdGuidenceService');
export const dbTypeServiceFactory = (i: any) => i.get('dbTypeService');
export const packagesLocalHistoryServiceFactory = (i: any) => i.get('packagesLocalHistoryService');
export const projectsLocalHistoryServiceFactory = (i: any) => i.get('projectsLocalHistoryService');
export const logsLocalHistoryServiceFactory = (i: any) => i.get('logsLocalHistoryService');
export const fileUploader = (i: any) => i.get('fileUploader');
export const gridHelpersFactory = (i: any) => i.get('gridHelpers');
export const SettingsActionsFactory = (i: any) => i.get('SettingsActions');

export const angular1Providers = [
    { provide: 'SettingsActions', useFactory: SettingsActionsFactory, deps: ['$injector'] },
    { provide: '$q', useFactory: $qFactory, deps: ['$injector'] },
    { provide: 'Upload', useFactory: $UploadFactory, deps: ['$injector'] },   
    { provide: 'JobsNormalInterval', useFactory: $JobsNormalIntervalFactory, deps: ['$injector'] },
    { provide: 'JobsSpeedInterval', useFactory: $JobsSpeedIntervalFactory, deps: ['$injector'] },
    { provide: '$document', useFactory: $documentFactory, deps: ['$injector'] },
    { provide: 'gridHelpers', useFactory: gridHelpersFactory, deps: ['$injector'] },
    { provide: '$filter', useFactory: $filterFactory, deps: ['$injector'] },
    { provide: '$compile', useFactory: $compileFactory, deps: ['$injector'] },
    { provide: '$translate', useFactory: $translateFactory, deps: ['$injector'] },
    { provide: '$stateParams', useFactory: $stateParamsFactory, deps: ['$injector'] },
    { provide: '$state', useFactory: $stateFactory, deps: ['$injector'] },
    { provide: '$element', useFactory: $elementFactory, deps: ['$injector'] },
    { provide: 'LeadTimeActions', useFactory: LeadTimeActionsFactory, deps: ['$injector'] },
    { provide: '$rootScope', useFactory: $rootScopeFactory, deps: ['$injector'] },
    { provide: '$scope', useFactory: $scopeFactory, deps: ['$injector'] },
    { provide: '$ngRedux', useFactory: $ngReduxFactory, deps: ['$injector'] },
    { provide: '$uibModal', useFactory: $uibModalFactory, deps: ['$injector'] },
    { provide: '$http', useFactory: $httpFactory, deps: ['$injector'] },
    { provide: 'statuses', useFactory: $statusesFactory, deps: ['$injector'] },
    { provide: 'api', useFactory: apiFactory, deps: ['$injector'] },
    { provide: 'authorizationService', useFactory: authorizationServiceFactory, deps: ['$injector'] },
    { provide: 'jobCompletitionService', useFactory: JobCompletitionServiceFactory, deps: ['$injector'] },
    { provide: 'consts', useFactory: constsFactory, deps: ['$injector'] },
    { provide: 'popUpModal', useFactory: popUpModalFactory, deps: ['$injector'] },
    { provide: 'processDetailsModalService', useFactory: processDetailsModalServiceFactory, deps: ['$injector'] },
    { provide: 'shepherdGuidenceService', useFactory: shepherdGuidenceServiceFactory, deps: ['$injector'] },
    { provide: 'dbTypeService', useFactory: dbTypeServiceFactory, deps: ['$injector'] },
    { provide: 'packagesLocalHistoryService', useFactory: packagesLocalHistoryServiceFactory, deps: ['$injector'] },
    { provide: 'fileUploader', useFactory: fileUploader, deps: ['$injector'] },
    { provide: 'projectsLocalHistoryService', useFactory: projectsLocalHistoryServiceFactory, deps: ['$injector'] },
    { provide: 'logsLocalHistoryService', useFactory: logsLocalHistoryServiceFactory, deps: ['$injector'] }
];



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/angular1-providers.ts